import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/index.css'
import { ThemeProvider } from 'next-themes'
import useIsomorphicLayoutEffect from 'use-isomorphic-layout-effect'

// グローバルなReactの型定義
declare global {
  interface Window {
    React: typeof React;
  }
}

// Reactの初期化を確実に行う
if (typeof window !== 'undefined') {
  // Reactのメソッドを確実に初期化
  window.React = Object.assign(React, {
    createContext: React.createContext.bind(React),
  });
}

// useLayoutEffectの設定
if (typeof window !== 'undefined') {
  React.useLayoutEffect = useIsomorphicLayoutEffect;
}

function initializeApp() {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    console.error('Failed to find root element');
    return;
  }

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
        <App />
      </ThemeProvider>
    </React.StrictMode>,
  );
}

// DOMの読み込みを待つ
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApp);
} else {
  initializeApp();
}
